import { useState } from "react";
import TransactionIssues from "../../Components/TransactionIssues";
import TicketIssues from "../../Components/TicketIssues";
import { useIssues } from "./useIssues";
import styles from "./index.module.css";

export default function IssuesPage() {
  const [iboSearch, setIboSearch] = useState("");

  const {
    transactionIssues,
    ticketIssues,
    refetchTransactionIssues,
    refetchTicketIssues,
    isTransactionIssuesLoading,
    isTicketIssuesLoading,
    isTransactionIssuesRefetching,
    isTicketIssuesRefetching,
    transactionIssuesError,
    ticketIssuesError,
    resolveTransactionIssue,
    resolveTicketIssue,
  } = useIssues();

  return (
    <div className={styles.pageContainer}>
      <div className={styles.searchRow}>
        <label className={styles.searchLabel}>Search by IBO:</label>
        <input
          type="text"
          value={iboSearch}
          onChange={(e) => setIboSearch(e.target.value)}
          placeholder="IBO"
          className={styles.searchInput}
        />
      </div>

      <div className={styles.section}>
        <div className={styles.sectionTitle}>Transaction Issues</div>
        <TransactionIssues
          issues={transactionIssues}
          isLoading={isTransactionIssuesLoading}
          isRefetching={isTransactionIssuesRefetching}
          error={transactionIssuesError}
          resolveTransactionIssue={resolveTransactionIssue}
          refetch={refetchTransactionIssues}
          iboSearch={iboSearch}
        />
      </div>

      <div className={styles.section}>
        <div className={styles.sectionTitle}>Ticket Issues</div>
        <TicketIssues
          issues={ticketIssues}
          isLoading={isTicketIssuesLoading}
          isRefetching={isTicketIssuesRefetching}
          error={ticketIssuesError}
          resolveTicketIssue={resolveTicketIssue}
          refetch={refetchTicketIssues}
          iboSearch={iboSearch}
        />
      </div>
    </div>
  );
}
